import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface ITranslationResource {
  prefix: string;
  suffix: string;
}

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public resources: ITranslationResource[]
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map((resource) => {
      return this.http.get(`${resource.prefix}${lang}${resource.suffix}`).pipe(
        catchError((res) => {
          console.error('Could not load translation file:', res);
          return of({});
        })
      );
    });

    // Junta os arquivos em um único objeto
    return forkJoin(requests).pipe(
      map((response) => {
        return response.reduce((a, b) => {
          return { ...a, ...b };
        });
      })
    );
  }
}
